@import '../../../scss/global_v2_member_light-vars.css';

.express-pay-input-container {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: rgba(var(--vip-core-color-neutral-25), 0.7);
  border-radius: 0.5rem;
  border: 2px solid var(--vip-color-stroke-subtle);
  cursor: text;
  position: relative;
  font-family: var(--vip-brand-font-fam-body-sm);
  max-height: fit-content;

  &.required {
    margin-bottom: 1.75rem;
  }

  label {
    color: var(--vip-color-text-emphasis);
    pointer-events: none;
    cursor: text;
    position: absolute;
    top: 0;
    left: 0.75rem;
    transform: translateY(50%);
    font: var(--vip-typography-body-md-regular);
    transition:
      font 150ms ease-out,
      top 150ms ease-out;
  }

  &:has(input:-webkit-autofill) label,
  &:has(input:autofill) label {
    top: -4px;
    font: var(--vip-typography-body-xxs-regular);
    color: var(--vip-color-text-muted);
  }

  &:focus-within {
    border-color: var(--vip-color-stroke-emphasis);
  }

  &:focus-within,
  &.filled {
    label {
      color: var(--vip-color-text-muted);
      font: var(--vip-typography-body-xxs-regular);
      top: -4px;
    }
  }

  &.error {
    border-color: var(--vip-color-stroke-error);
    background-color: var(--vip-brand-color-danger-light);

    label {
      color: var(--vip-color-text-error);
    }
  }

  input {
    padding: 1.25rem 0.75rem 0.25rem;
    border-radius: 0.5rem;
    color: var(--vip-core-color-neutral-700);
    font: var(--vip-typography-body-md-healthy);
    border: none;
    background-color: transparent;
    width: 100%;
    margin: 0;
    &:focus,
    &:active,
    &.filled {
      outline: none;
    }
  }

  &.rounded {
    border-radius: 9999px;

    label {
      left: 1rem;
    }

    input {
      padding: 1.25rem 1rem 0.25rem;
      border-radius: 9999px;
    }
  }

  .button-container {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0.25rem;

    button {
      padding: 0.5rem 1.5rem;
    }
  }
}
